/**
 * Phase 3 - Chinese translations module
 */
import enBase from './en.js';
import { translationsZh } from '../../utils/translations/translations.zh.js';
import { plansTranslationsZh } from '../../utils/translations/plans/plansTranslations.zh.js';

const merged = { ...enBase, ...translationsZh, ...plansTranslationsZh };
export default merged;
